module.exports={

    popupWrapper:'newpopupwrapper block md:hidden',
    popup:'newpopup relative',
    closeButton:'newpopuplosebutton absolute text-4v',
    contentWrapper:'newpopupcontentwrapper',
    
}